<div class="loader-container">
  <div class="loader">
    <div class="loader-circle"></div>
    <div class="loader-circle"></div>
  </div>
  <div class="loader-text">Chargement des configurations...</div>
  <div class="progress-bar">
    <div class="progress" [style.width.%]="progress"></div>
  </div>
</div>